import { ReactNode } from 'react'
import { OverviewMappingItem, EntityValue, OverviewV2MetaItem } from './types'
import { getAbbreviatedNumber } from 'components/Income/Income'
import { VerticalEntity } from 'store/verticals/types'
import { UNKNOWN } from '../../utils/constants'

export const MISSING_VALUE = 'N/A'
const formatNumber = (num: number) => {
  const formattedNumber = getAbbreviatedNumber(num)
  return `${formattedNumber.finalNumber}${formattedNumber.unit}`
}

const getDisplayValue = (
  item: OverviewMappingItem,
  data: object | undefined,
  verticalEntity?: VerticalEntity | null,
): ReactNode => {
  const rawValue = data?.[item.key as keyof typeof data] as EntityValue

  if (item.render) return item.render(rawValue, verticalEntity)
  if (Array.isArray(rawValue)) return rawValue.join(', ')
  if (item.key === 'founded') return rawValue ? `Founded ${rawValue ?? ''}` : UNKNOWN
  if (typeof rawValue === 'number') return formatNumber(rawValue)
  if (rawValue) return String(rawValue)
  return MISSING_VALUE
}

export const buildMetaItemsFromMapping = (
  overviewMapping: OverviewMappingItem[],
  data: object | undefined,
  verticalEntity?: VerticalEntity | null,
): Omit<OverviewV2MetaItem, 'icon'>[] =>
  overviewMapping.map(item => ({
    key: item.key,
    label: item.label,
    value: getDisplayValue(item, data, verticalEntity),
    icon: item?.icon,
  }))
